import { SVGProps, Ref, forwardRef } from 'react';

export const PhoneOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.964 2.138c-1.299.528-2.074 1.177-2.522 1.817-.557.795-.767 1.803-.57 3.085.414 2.692 2.568 6.114 5.782 9.327s6.629 5.356 9.311 5.763c1.278.194 2.283-.018 3.078-.577.64-.45 1.289-1.227 1.818-2.525l-3.683-2.561-2.088.914c-.94.412-2.15.479-3.218-.165-.794-.478-1.98-1.318-3.363-2.7-1.39-1.389-2.232-2.58-2.709-3.374-.636-1.057-.575-2.251-.176-3.184l.91-2.129zM9.58 5.619 5.67 0c-9.204 2.598-5.905 11.027.712 17.64 6.616 6.614 15.013 9.877 17.618.683l-5.621-3.909-3.011 1.318c-.51.224-1.09.23-1.567-.057-.674-.406-1.745-1.157-3.02-2.432-1.281-1.281-2.034-2.355-2.438-3.028-.284-.472-.28-1.044-.064-1.55z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
PhoneOutlinedSize24Glyph.displayName = 'PhoneOutlinedSize24Glyph';
